import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import Modal from '@mui/material/Modal';
import ReactDOM from 'react-dom';
//import BillPrint from '../sale/Bill';

const StockJournalCreate = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, token, logout, branchstate } = useAuth();
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const handleInputChange = (newValue) => newValue;
    const handleItemChange = (newValue) => newValue;
    const [selectedBank, setSelectedBank] = useState("");
    const [dropdownBankOptions, setDropdownBankOptions] = useState([]);
    const branchId = 0;
    const [remarks, setRemarks] = useState("");

    const formatDateForInput = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const today = new Date();
    const [BillDate, setBillDate] = React.useState(formatDateForInput(today));

    const fetchItemOptions = async (inputValue) => {
        // Early return if input value length is less than or equal to 2
        if (inputValue.length <= 2) {
            return [];
        }
        try {
            // Fetch data from the API
            const response = await fetchData('StockJournalApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: `${item.ItemName} (${item.BalanceStock})`,
                        //label: item.ItemName,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    // Handle customer selection
    const fetchmaxbillno = (invtype) => {
        fetchData('StockJournalApi', `/MaxBillno/${companyId}/${branchId}/${invtype}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setFormData(prevData => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillPrefix: data.BillPrefix,
                    FinYear: data.FinYear,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno', error);
            });
    };

    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);
        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemOptions.find((itemDetail) => itemDetail.Id === selectedItemId);
        if (selectedItemDetail) {
            setModalData({
                ...modalData,
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemId: selectedOption ? selectedOption.value : '',
                QuantityStock: selectedItemDetail.QuantityStock,
            });
        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemId: selectedOption ? selectedOption.value : '',
                QuantityStock: '',
            });
        }
    };

    useEffect(() => {
        fetchmaxbillno(0);
    }, []);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    // const [formData, setFormData] = useState([]);
    const [formData, setFormData] = useState({
        PaidAmount: 0,
        BalanceAmount: 0,
    });

    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const parseAndFix = (val) => parseFloat(val) || 0;

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        // Update the input field immediately
        const updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);
        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record            
        }
    };

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        QuantityInPackets: '0',
        Rate: '',
        Amount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
    });

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        // Prevent duplicate item with same rate
        const duplicateExists = invoicedeatils.some(
            item => item.ItemId === modalData.ItemId
        );

        if (duplicateExists) {
            isValid = false;
            alert("This item with the same rate is already added.");
            return;
        }

        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);
            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
            });
            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');
            //closeModal();            
        } else {
            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }
    };

    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }
        setInvoicedeatils((prevDetails) => {
            const newDetails = [...prevDetails];
            newDetails[index] = {
                ...newDetails[index],
                [name]: value,
            };
            const updatedItemData = newDetails;
            return updatedItemData;
        });
    };

    const checkStockLevels = (item) => {
        if (item.StockFromBranchId === "1") {
            return item.Quantity > item.PBVRStock;
        } else if (item.StockFromBranchId === "2") {
            return item.Quantity > item.CHERIStock;
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (!formData.BillNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }
        const StockMaster = {
            BranchId: branchId,
            CompanyId: companyId,
            Remarks: remarks,
            BillDate: BillDate,
            BillNumber: formData.BillNumber,
            CreatedBy: userId,
            FinYear: formData.FinYear,
        }
        const CreateData = {
            StockJournal: StockMaster,
            StockJournalDetails: invoicedeatils
        };
        // Validate form data here if needed
        postData('StockJournalApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                // const SaleId = response.kotId;
                // handlePrint(SaleId);
                history.push('/StockJournalIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex" style={{ marginTop: '-30px' }}>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>STOCK JOURNAL CREATE</h6>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{ height: "25px", borderRadius: "10px" }}
                    >
                        {isLoading ? <CircularProgress size={22} color="inherit" /> : "Save"}
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/StockJournalIndex",
                            state: { from: "/StockJournalCreate" },
                        }}
                        onClick={() => {
                            localStorage.setItem("shouldReload", "true");
                        }}
                        style={{ height: "25px", borderRadius: "10px", marginRight: "5px", marginLeft: '5px' }}
                    >
                        Back To List
                    </Button>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex">
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: '#FFFDF6', maxHeight: '500px', overflowY: 'auto', width: '100%', boxShadow: '0 4px 6px rgba(0,0,0,0.5)' }}>

                        <div className="w-full mb-2 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                                    Bill Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formatDateForInput(BillDate)}
                                    onChange={(e) => setBillDate(e.target.value)}
                                    type="date"
                                    name='BillDate'
                                    readOnly
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                                    Bill No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={`${formData.BillPrefix || ''}${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="BILL NUMBER"
                                    name='BillNumber'
                                    readOnly
                                />
                            </div>
                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                                    Remarks
                                    {/* <span className="text-red-500">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                    type="text"
                                    placeholder="Remarks"
                                    name='remarks'
                                />
                            </div>
                        </div>

                        <div className="w-full mb-2 flex">
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#FFFDF6' }}>
                                                <th style={{ padding: '3px', backgroundColor: '#FFFDF6', color: 'black', fontSize: '12px', textTransform: 'uppercase' }}>Item Name</th>
                                                <th style={{ padding: '3px', backgroundColor: '#FFFDF6', textAlign: 'right', fontSize: '12px', color: 'black', textTransform: 'uppercase' }}>Qty</th>
                                                <th style={{ padding: '3px', backgroundColor: '#FFFDF6', textAlign: 'right', fontSize: '12px', color: 'black', textTransform: 'uppercase' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => {
                                                const isStockExceeded = checkStockLevels(invdetail);
                                                return (
                                                    <tr key={index} style={{ width: '100%', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                        <td style={{ padding: '3px', fontSize: '13px', width: '35%', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <label style={{ marginTop: '9px', color: 'black' }}>
                                                                {/* {`${invdetail.ItemName} (${invdetail.BalanceStock})`} */}
                                                                {invdetail.ItemName}
                                                            </label>
                                                        </td>
                                                        <td style={{ padding: '3px', fontSize: '13px', width: '6%', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <input
                                                                type="number"
                                                                value={invdetail.Quantity}
                                                                onChange={(e) => handleCalculation(e, index, 'Quantity')}
                                                                style={{ textAlign: 'right', marginRight: '10px', width: '100%' }}
                                                                name="Quantity"
                                                            />
                                                        </td>

                                                        <td style={{ padding: '3px', marginTop: '-15px', width: '5%', textAlign: 'right', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <IconButton style={{ padding: '8px', color: 'red' }} onClick={() => removeRecord(index)}>
                                                                <DeleteIcon style={{ fontSize: '19px', marginTop: '-5px' }} />
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>

                                    </table>
                                </TableContainer>
                            </div>
                        </div>
                    </div>

                    <div className="w-full mb-4 flex" style={{ marginLeft: '10px', width: '50%', marginTop: '10px' }}>
                        <div className="w-full pr-4">
                            <div className="rounded-lg shadow-lg p-6" style={{ backgroundColor: '#F1EFEC' }}>
                                {errorMessageModel && <p className="text-red-500">{errorMessageModel}</p>}
                                <p style={{ color: '#643843', fontSize: '12px' }}>SELECT ITEMS FROM HERE .....</p>
                                <div className="w-full mb-2 flex">
                                    <div className="w-full mr-3">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                                            Item Name
                                        </label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={fetchItemOptions}
                                            onInputChange={handleItemChange}
                                            onChange={handleChangeDrop}
                                            value={selectedItemOption}
                                            isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    minHeight: "30px",
                                                    height: "30px",
                                                    fontSize: "14px",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "30px",
                                                    padding: "0 6px",
                                                }),
                                                indicatorsContainer: (base) => ({
                                                    ...base,
                                                    height: "30px",
                                                }),
                                                menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    fontSize: "14px",
                                                }),
                                            }}
                                        />
                                    </div>
                                    <div className="w-1/4 mr-2">
                                        <Button
                                            style={{ backgroundColor: '#22515fff', color: 'white', height: '26px', marginRight: '8px', marginTop: '25px' }}
                                            onClick={saveModalData}
                                            className="linkcolor"
                                        >
                                            <span style={{ fontSize: '12px' }}>Add</span>
                                        </Button>
                                    </div>
                                </div>
                                <div className="w-full mb-2 flex">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </Fragment >
    );
};

export default StockJournalCreate;